import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface YearsAndMonts {
  years: number;
  months: number;
}

export interface IncomeObj {
  employment: AmountValue;
  business: AmountValue;
  other: AmountValue;
  retirement: AmountValue;
  gender: string;
  children: number;
  netIncome: AmountValue;
  age: YearsAndMonts;
  calculatedRetirementAge: YearsAndMonts;
  plannedRetirementAge: YearsAndMonts;
  retired: boolean;
}

export interface Income {
  clientData: IncomeObj;
  partnerData?: IncomeObj;
}

const income = (currency: Currency) => ({
  employment: { value: 0, currency: currency },
  business: { value: 0, currency: currency },
  other: { value: 0, currency: currency },
  retirement: { value: 0, currency: currency },
  gender: '',
  children: 0,
  netIncome: { value: 0, currency: currency },
  age: { years: 0, months: 0 },
  calculatedRetirementAge: { years: 0, months: 0 },
  plannedRetirementAge: { years: 0, months: 0 },
});

export const getInitialValues = (partner: boolean, currency: Currency) => ({
  clientData: income(currency),
  partnerData: partner ? income(currency) : undefined,
});
